import { Section } from '@web_opxp/components';
import { ConfigSelectors, renderMultilineLoca, useTranslation } from '@web_opxp/features';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { SKELETON_CLASSNAME } from '../../base/constants';
import ENV from '../../base/env';
import { ChallengeSelectors } from '../../challenge';
import HintPopup from '../../components/HintPopup/HintPopup';
import { IState } from '../../store/state';
import { isLoading } from '../selectors';
import ChallengeHighscoresWrapper from './ChallengeHighscoresWrapper';
import './ChallengeLeaderboard.scss';
import ChallengeProgress from './ChallengeProgress';
import RadioButton from './buttons/RadioButton';

const ChallengeLeaderboard = () => {
  const { t } = useTranslation();
  const isActivated = useSelector(ChallengeSelectors.isChallengeActive);
  const workoutId = isActivated ? ChallengeSelectors.getTodaysChallengeWorkoutId() : null;
  const isHighscoresLoading = useSelector(isLoading);
  const isVisible = isActivated && workoutId !== null;
  const domain = useSelector<IState>((s) => ConfigSelectors.getDomainForWorkoutId(s, workoutId ?? 0));

  const [mode, setMode] = useState<string>('progress');
  const radioItems = [
    {
      key: 'progress',
      title: t('ChallengeLeaderboard.Leaderboard.Progress'),
    },
    {
      key: 'ranking',
      title: t('ChallengeLeaderboard.Leaderboard.Ranking'),
    },
  ];

  if (!isVisible) {
    return null;
  }

  const bgImgSrc = `${ENV.AssetsBaseUrl}/feature/challenge/leaderboard-trophy.png`;
  const skeletonClass = isHighscoresLoading ? SKELETON_CLASSNAME : '';
  const domainTitle = `$t(common:Domain.Title.${domain})`;
  const subtitle =
    mode === 'progress'
      ? t('ChallengeLeaderboard.SubtitleProgress')
      : t('ChallengeLeaderboard.Subtitle', { domain: domainTitle });
  const hintPopupContent = renderMultilineLoca(t('ChallengeLeaderboard.Hint.ContentLines'));
  return (
    <Section>
      <div className="row">
        <div className="col">
          <div className="leaderboard-wrapper">
            <h4 className="leaderboard-title">{t('ChallengeLeaderboard.Title')}</h4>
            <div className="leaderboard-hint">
              <HintPopup iconSize={24} okButtonLabel={t('ChallengeLeaderboard.Hint.CTA')}>
                <h3>{t('ChallengeLeaderboard.Hint.Title')}</h3>
                {hintPopupContent}
              </HintPopup>
            </div>
            <div className="leaderboard-img" style={{ backgroundImage: `url(${bgImgSrc})` }} />
            <div className="leaderboard-content">
              <h3 className={`leaderboard-subtitle ${skeletonClass}`}>{subtitle}</h3>
              <RadioButton items={radioItems} activeItem={mode} onClick={setMode} />
              {mode === 'ranking' ? <ChallengeHighscoresWrapper /> : <ChallengeProgress />}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ChallengeLeaderboard;
